import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FoodcourtmenuService {

  private dataSubject = new BehaviorSubject<string>('Initial data');
  public data$ = this.dataSubject.asObservable();
  excelContent: any;

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  sendData(data: string) {
    this.dataSubject.next(data);
  }

  setExcelData(data) {
    this.excelContent = data;
  }

  getExcelData() {
    return this.excelContent
  }

  getParkByCLAId() {
    return this.apiService.get(`${APIs.getParkByClaId}?claId=${localStorage.getItem('claAdminId')}`).pipe(map(response => {
      if (response.isValid) {
        // this.parkDropDownDetails.next(response.list);
        console.log(response.list);
      }
      return response;
    }))
  }

  getMenuListByVendor(id: string): Observable<any> {
    return this.apiService.get(APIs.foodCourtMenuList + '/' + id).pipe(map(response => {
      return response;
    }));
  }

  removeMenu(body: any): Observable<any> {
    return this.apiService.post(APIs.removeMenu, body).pipe(map(response => {
      return response;
    }));
  }

  removeMenuBulk(body: any): Observable<any> {
    return this.apiService.post(APIs.removeMenuBulk, body).pipe(map(response => {
      return response;
    }));
  }

  foodMenuDetails(id: string): Observable<any> {
    return this.apiService.get(APIs.foodMenuDetails + '/' + id).pipe(map(response => {
      return response;
    }));
  }

  createBulkUploadFoodMenu(data): Observable<any> {
    return this.apiService.post(APIs.bulkUploadFoodMenuCoupon, data).pipe(
      map((response) => {
        return response;
      })
    );
  }
}
